import { environment } from 'src/environments/environment';
import { Component, OnInit, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
// [[Providers]]
import { CustomerUserService } from 'src/project/services/panel/client/marketplace/customer/user/user.service';
import { CollectiveMarketplaceService } from '~services/collective/client/marketplace/marketplace.service';
import { CollectiveMarketplaceCartService } from '~services/collective/client/marketplace/cart/cart.service';
import { CollectiveMarketplaceCoreVisualBannerService } from '~services/collective/client/marketplace/core/visual/banner/banner.service';
// [[Providers: Component]]
import { CollectiveMarketplaceCoreSubscriptionKitService } from '~services/collective/client/marketplace/core/subscription/kit/subscription-kit.service';
// ]
// [[Interfaces/Models do Componente]]
import { Meta } from '~components/pagination/interfaces/pagination';
// ]
// [[Functions]]

// ]
@Component({
  selector: 'app',
  templateUrl: './component.html',
  styleUrls: ['./component.scss'],
})
export class SubscriptionComponent implements OnInit {
  /**
   * Base de uso em Component
   */
  public environment = environment;
  messageProcess = false;
  messageIsError: any;
  profile: any;
  marketplace: any = null;
  cart: any = null;
  banners: any = null;
  banners_fnc_cta: any = null;

  constructor(
    /**
     * Serviços da Aplicação
     */
    private titleService: Title,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    /**
     * Base de uso em Component
     */
    private userService: CustomerUserService,
    private collectiveMarketplaceService: CollectiveMarketplaceService,
    private collectiveMarketplaceCartService: CollectiveMarketplaceCartService,
    private collectiveMarketplaceCoreVisualBannerService: CollectiveMarketplaceCoreVisualBannerService,
    /**
     * Services
     */
    private collectiveMarketplaceCoreSubscriptionKitService: CollectiveMarketplaceCoreSubscriptionKitService
  ) {}

  /**
   * on init
   */
  ngOnInit() {
    this.ipBuildEcommerceDependencies();
    this.router.events.subscribe((ev) => {
      if (ev instanceof NavigationEnd) {
        this.ngAfterViewInit();
      }
    });
  }

  /**
   * build ecommerce dependencies
   */
  ipBuildEcommerceDependencies() {
    /**
     * Base
     *
     * Request da base de uso.
     */
    // PROFILE
    this.userService.getUser().subscribe((Profile: any) => {
      if (Profile != null) {
        if (JSON.parse(Profile) != null) {
          this.profile = JSON.parse(Profile);
        }
      }
    });
    // MARKETPLACE
    this.collectiveMarketplaceService.getMarketplace().subscribe((Marketplace: any) => {
      if (Marketplace != null) {
        if (JSON.parse(Marketplace) != null) {
          this.marketplace = JSON.parse(Marketplace);
          /**
           *
           * CONFIGURAÇÕES ADICIONAIS DESTE `COMPONENTE`
           *
           */
          // SEO
          this.titleService.setTitle(this.marketplace.name);
        }
      }
    });
    // CART
    this.collectiveMarketplaceCartService.getCart().subscribe((Cart: any) => {
      if (Cart != null) {
        if (JSON.parse(Cart) != null) {
          this.cart = JSON.parse(Cart);
        }
      }
    });
    // BANNERS
    this.banners_fnc_cta = function (banner: any) {
      if (banner.url != '') {
        document.location = banner.url;
      }
      return false;
    };
    this.collectiveMarketplaceCoreVisualBannerService.getBanners().subscribe((Data: any) => {
      if (Data != null) {
        if (JSON.parse(Data) != null) {
          this.banners = JSON.parse(Data);
        }
      }
    });
  }

  /**
   * after view init
   */
  ngAfterViewInit() {
    this.collectiveMarketplaceCoreSubscriptionKitServiceIndex(1);
  }

  /**
   * on destroy
   */
  ngOnDestroy() {}

  kits: any;
  kitsMeta: Meta;
  /**
   * Collectives marketplace core subscription kit service index
   * @param page
   */
  collectiveMarketplaceCoreSubscriptionKitServiceIndex(page: number) {
    var _ = this.collectiveMarketplaceCoreSubscriptionKitService.index({ per_page: 25, page: page });
    if (_ !== null) {
      _.subscribe(
        (response: any) => {
          this.kits = response.data;
          this.kitsMeta = response.meta;
        },
        (error) => {
          this.messageProcess = false;
          this.messageIsError = this.collectiveMarketplaceCoreSubscriptionKitService.error.throw(error);
        }
      );
    }
  }
}
